export default "__VITE_PUBLIC_ASSET__d3009863__"